import React from 'react';

import { RouteObject } from 'react-router-dom';

const ResourcePnl = React.lazy(
  () => import('@/pages/ResourceDetails/views/Pnl'),
);

export const resourceDetailPath = {
  Pnl: '',
};

export const resourceDetailRoutes: RouteObject[] = [
  { index: true, element: <ResourcePnl /> },
];
